export const IS_CONNECTED_ACCOUNTS_LOADING = "IS_CONNECTED_ACCOUNTS_LOADING";
export const SET_CONNCTED_ACCOUNT = "SET_CONNECTED_ACCOUNT";
export const SET_CONNECTED_ACCOUNT_ERROR = "SET_CONNECTED_ACCOUNT_ERROR";
export const RESET_CONNECTED_ACCOUNT = "RESET_CONNECTED_ACCOUNT"